import React from "react";
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components
import AppLayout from "pages/AppLayout";
import Contacts from "pages/contacts/Contacts";
import Companies from "pages/companies/Companies";
import Dashboard from "pages/dashboard/Dashboard";
import Email from "pages/Email";
import Financial from "pages/Financial";
import Leads from "pages/leads/Leads";
import Login from "pages/login/Login";
import Profile from "pages/Profile";
import Settings from "pages/Settings";
import Users from "pages/Users";
import NotFound from "pages/NotFound";

// actions
import { useAuthUser, useDispatch } from 'shared/state';

/* TODO: Add redirection to specific router basec on role */
const App = () => {
    let location = useLocation();
    const [cookies] = useCookies(['user_auth']);
    const dispatch = useDispatch();
    const { user } = useAuthUser();

    React.useEffect(() => {
        if(Object.keys(user).length === 0 && cookies.user_auth !== undefined) {
            dispatch({ type: 'LOGGED_IN_USER', payload: cookies.user_auth });
        }
    }, [user, cookies, dispatch]);

    const AuthWrapper = ({ children }) => {
        return cookies && cookies.user_auth !== undefined
            ? children
            : <Navigate to="/login" state={{ from: location }} replace />;
    };

    return (
        <div className="app">
            <ToastContainer
                icon={false}
                hideProgressBar
                theme="colored" />
            <Routes>
                { /* private routes (request authentication) */ }
                <Route element={<AppLayout />}>
                    <Route path='/' element={
                        <AuthWrapper><Dashboard /></AuthWrapper>
                    }/>
                    <Route path='/contacts' element={
                        <AuthWrapper><Contacts /></AuthWrapper>
                    }/>
                    <Route path='/companies' element={
                        <AuthWrapper><Companies /></AuthWrapper>
                    }/>
                    <Route path='/leads' element={
                        <AuthWrapper><Leads /></AuthWrapper>
                    }/>
                    <Route path='/email' element={
                        <AuthWrapper><Email /></AuthWrapper>
                    }/>
                    <Route path='/financial' element={
                        <AuthWrapper><Financial /></AuthWrapper>
                    }/>
                    <Route path='/settings' element={
                        <AuthWrapper><Settings /></AuthWrapper> }/>

                    <Route path="/settings/users" element={
                        <AuthWrapper><Users /></AuthWrapper>
                    } />

                    <Route path='/profile' element={
                        <AuthWrapper><Profile /></AuthWrapper>
                    }/>
                </Route>

                { /* public routes */ }
                <Route path="/login" element={ <Login /> } />
                <Route path="*" element={ <NotFound /> } />
            </Routes>
        </div>
    );
}

export default App;
